import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router
} from '@angular/router';

import { SalemethodService } from '../api/salemethod/salemethod.service';
import { PanierService } from '../manage/panier/panier.service';

@Injectable({
  providedIn: 'root'
})

export class GuardProductService implements CanActivate {

  constructor(
    private panierMan: PanierService,
    private smApi: SalemethodService,
    private router: Router,
  ) { }


  canActivate(
    next: ActivatedRouteSnapshot|any,
    state: RouterStateSnapshot): any {

    return new Promise(resolve => {

      this.panierMan.initPanier();

      this.smApi.initSM().then(data => {

        if (data && data.length < 1 && next.routeConfig["path"].includes("product")) {

          this.router.navigate(["/disabledorder"]);
        }

        resolve(true);

      });

    })

  }
}
